import React, { Fragment, useContext, useEffect } from 'react';
import ThirdPartyQuestionnaireSidebar from "../thirdPartyQuestionnarieSidebar/thirdPartyQuestionnaireSidebar";
import ThirdPartyQuestionsToAsk from "../thirdPartyQuestionsToAsk/thirdPartyQuestionsToAsk";
import { IGetThirdPartyQuestionnarieApiResponse } from "../../../Models/thirdPartyQuestionnarieModels";
import { UserContext, UserPayload } from "../../../Context/userContext";
import agent from "../../../API/apiCalls";
import {
    IThirdPartyQuestionnaireContext,
    ThirdPartyQuestionnaireContext,
} from "../../../Context/thirdPartyQuestionnaireContext";

const ThirdPartyContentOuterLayer = () => {

    const { setShowLoader } = useContext(UserContext) as UserPayload;
    const { setQuestionsToAsk, questionsToAsk } = useContext(ThirdPartyQuestionnaireContext) as IThirdPartyQuestionnaireContext;

    const GetThirdPartyQuestionnaireApi = async () => {
        try {
            setShowLoader(true);
            const response: IGetThirdPartyQuestionnarieApiResponse = await agent.GetThirdPartyQuestionnaire.get();
            console.log("Printing response of get third party questionnarie", response);
            setShowLoader(false);
            if(!response?.isAxiosError) {
                setQuestionsToAsk(response.value.categoriesTree);
            }
        }
        catch (err) {
            console.error("Printing error of get third party questionnarie", err);
            setShowLoader(false);
        }
    }

    useEffect(() => {
        (async () => {
            await GetThirdPartyQuestionnaireApi();
        })()
    }, []);

    return (
        <Fragment>
            <ThirdPartyQuestionnaireSidebar sections={questionsToAsk} />
            <ThirdPartyQuestionsToAsk sections={questionsToAsk} />
        </Fragment>
    );
};

export default ThirdPartyContentOuterLayer;